import BucketApiRequest from "./BucketApiRequest";
import { GET_EMPLOYER_POSITION_CODES } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetEmployerPositionCodes extends BucketApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return GET_EMPLOYER_POSITION_CODES;
  };

  getBody = () => {
    return this.body;
  };
}
